import { alerts } from 'keys';
import { useCallback } from 'react';
import { useAlert } from 'components/Alerts/hooks';
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { SvgIcon } from '@mui/material';
import { Add } from '@mui/icons-material';

const useHeaderBtns = () => {
    const { setAlerts } = useAlert()

    const openNewTicketAlert = useCallback(() => {
        setAlerts(alerts.contactUs, true)
    }, [])

    const headerBtns = [
        {
            id: 1,
            color: "dark",
            icon: <Add fontSize='small'/>,
            label: "פנייה חדשה",
            action: () => openNewTicketAlert(),
            size:"small"
        }
    ]

    return headerBtns
}

export default useHeaderBtns